/**
 * Environment detection, mirroring `functions/src/utilities/environment.ts`.
 *
 * Used to gate development-only tooling out of the production bundle. The
 * check is positive rather than a denylist: anything unrecognised is treated
 * as production.
 */

export const DEV_PROJECT_ID = 'pride-pharmacy-delivery-dev';

export const getProjectId = (): string => process.env.REACT_APP_FIREBASE_PROJECT_ID ?? '';

export const isDevEnvironment = (): boolean => {
  const projectId = getProjectId();
  if (!projectId) return false;
  return projectId === DEV_PROJECT_ID || projectId.endsWith('-dev');
};
